import { DatePipe } from '@angular/common';
import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { PersonDTO } from 'app/consulta-mark-list/interface/personDTO';
import { InfoClienteService } from 'app/consulta-mark-list/service/BehaviorSubject/infoClient.service';
import { ValidatorPerson } from 'app/consulta-mark-list/service/Validators/validator-person.service';
import { ConsultaMarkListService } from 'app/consulta-mark-list/service/consulta-mark-list.service';

import { Subscription } from 'rxjs';

import { AuthService, AvlaRestClientService } from 'base-angular-avla';
import { GenericTableAvlaService } from 'generic_table_avla_front_components';
import {
  AvlaGenericComponent,
  I18nService,
  InfoMessageDTO,
  MessageService,
  UiDatepickerDirective,
} from 'shared-angular-components-avla';

import { CountriesService } from '../../../service/countries.service';
import { CountryDto } from '../../../core/models/country-dto.model';
import { Select2OptionData } from '../../../core/models/select2-option-data';
import { TemporaryUnlockDTO } from 'app/consulta-mark-list/interface/temporaryUnlockDTO';
import { States } from 'app/core/enums';

@Component({
  selector: 'app-ml-modal',
  templateUrl: './ml-modal.component.html',
  styleUrls: ['./ml-modal.component.css'],
  providers: [DatePipe, UiDatepickerDirective],
})
export class MlModalComponent
  extends AvlaGenericComponent
  implements OnInit, OnDestroy
{
  @ViewChild('formregistro') formregisto: NgForm;
  @Output() changeStatus: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() reloadModal: EventEmitter<any> = new EventEmitter<any>();

  public findCountriesSubs;
  public countries: CountryDto[] = [];
  public countriesDto: Array<Select2OptionData> =
    new Array<Select2OptionData>();

  statusData: any[] = [];
  loadingImg = false;
  sinesterData: any[] = [];
  estadobool: boolean;
  userNameRegister = '';
  isoCode: any;
  ultima_observacion: string;
  estadoanterior: number;
  registrobool = false;
  validator = false;
  mostrarHistorialSiniestros = false;
  registroper = false;
  opcionestado: any = [];
  optionStatusActive: any = [];
  isStatusActive;
  sortBy = 'sinisterDate';
  sortOrder = 'desc';
  mostrarBtnHistorial = false;
  currentCountry: any;
  observation = '';
  currentUser = '';
  nameUser = '';
  lastObservation = '';
  registerPerson: PersonDTO = new PersonDTO();
  countryCodeSel = 'CL';
  infoClient: Subscription;
  countryDni = [
    { name: 'CHILE', isoCode: 'CL' },
    { name: 'PERÚ', isoCode: 'PE' },
    { name: 'MEXICO', isoCode: 'MX' },
    { name: 'BRASIL', isoCode: 'BR' },
  ];
  showButton = false;
  shouldShowStatusPerson = true;

  constructor(
    protected validatorPersonService: ValidatorPerson,
    protected restClientService: AvlaRestClientService,
    protected messageService: MessageService,
    protected router: Router,
    protected authService: AuthService,
    protected datePipe: DatePipe,
    protected renderer: Renderer2,
    protected marklistservice: ConsultaMarkListService,
    protected genericTableAvlaService: GenericTableAvlaService,
    protected infoClientSubjectService: InfoClienteService,
    public countriesService: CountriesService,
    protected i18n: I18nService
  ) {
    super(restClientService, messageService, router, authService, i18n);
  }
  ngOnInit() {
    this.getOptionState();
    this.currentUser = localStorage.getItem('storedUsername');
    this.currentCountry = this.countryIso(localStorage.getItem('cdCountry'));
    this.obteinCurrentInfo();
    this.loadCountries();
    this.loader.view = false;
  }

  reloadComponent(data: any) {
    this.reloadModal.emit(data);
  }

  obteinCurrentInfo() {
    this.infoClient = this.infoClientSubjectService
      .getInfoClienteBehaviorSubject()
      .subscribe({
        next: data => {
          console.log({ data });
          if (data) {
            this.initializerData(data);
            this.showButton =
              (this.shouldShowUnlockButton() || data.isTemporarilyUnlocked) &&
              (data.nameStatus === States.BLOQUEADO ||
                data.isTemporarilyUnlocked);
          }
        },
      });
  }

  initializerData(data: any): void {
    console.log('initializerData: ', data);
    this.isoCode = this.selectSufix(data.dniPerson);
    this.mostrarBtnHistorial = true;
    this.estadoanterior = data.idStatus;
    this.registroper = true;
    this.mostrarHistorialSiniestros = false;
    this.ultima_observacion = '';
    this.registerPerson = data;

    /** obtengo los siniestros de la persona */
    this.obteinHistorySinesterByPerson(this.registerPerson.idPerson);
    /** obtengo los cambios de estado de la persona */
    this.obteinHistoryStatusByIdPerson(this.registerPerson.idPerson);

    // if (this.shouldShowUnlockButton()) {
    // Ahora todos los usuarios podran ver cuanto tiempo le queda por desbloquear
    this.getTemporaryUnlockData(this.registerPerson);
    // }
  }

  getTemporaryUnlockData(person: PersonDTO) {
    if (person.isTemporarilyUnlocked) {
      this.marklistservice
        .getTemporaryUnlockInfo(person.idPerson)
        .subscribe(response => {
          person.unlockReason = response.unlockReason;
        });
    }
  }

  obteinHistoryStatusByIdPerson(idPerson) {
    this.marklistservice.getListStatusbyIdPerson(idPerson).subscribe(
      data => {
        if (this.errorInResponse(data)) {
          return;
        }

        this.userNameRegister = data[0].userNameRegister;
        console.log({ data });

        this.statusData = data.map(item => {
          this.cbDisabled(item);
          return {
            ...item,
            formattedRegisterDate: this.datePipe.transform(
              item.registerDate,
              'dd/MM/yyyy'
            ),
            dniPerson: this.registerPerson.dniPerson,
            namePerson: this.registerPerson.namePerson,
            personType: this.registerPerson.personType,
            identificationType: this.registerPerson.identificationType,
          };
        });
      },
      error => {
        this.routeAccordingError(error);
      }
    );
  }
  cbDisabled(item) {
    const disableIf = {
      BLOQUEADO: true,
      DESBLOQUEADO: false,
    };
    if (this.optionStatusActive) {
      const nameStatus = this.optionStatusActive.find(
        status => status.idStatus == item.idStatus
      )?.nameStatus;
      Object.assign(item, { isEditable: disableIf[nameStatus] });
    }
  }

  refresh() {
    this.obteinHistoryStatusByIdPerson(this.registerPerson.idPerson);
  }

  obteinHistorySinesterByPerson(idPerson) {
    this.marklistservice.getRegisterbyIdPerson(idPerson).subscribe(
      data => {
        if (this.errorInResponse(data)) {
          return;
        }
        this.lastObservation = data[data.length - 1]?.observation;
        this.sinesterData = data;
      },
      error => {
        this.routeAccordingError(error);
      }
    );
  }

  cambiarstatus(personDTO: PersonDTO) {
    this.loadingImg = true;
    const nameUser = this.currentUser;
    this.marklistservice.statuschange(personDTO, nameUser).subscribe(
      data => {
        if (this.errorInResponse(data)) {
          return;
        }
        this.messageService.announcedMessage(
          new InfoMessageDTO(
            'success',
            'Se ha realizado el cambio de estado',
            AvlaGenericComponent.TIME_NOTIFICATION
          )
        );
        this.changeStatus.emit(false);
      },
      error => {
        this.routeAccordingError(error);
      }
    );
    this.getOptionState();
  }

  getOptionState() {
    this.marklistservice.getStatusList(true).subscribe(
      data => {
        if (this.errorInResponse(data)) {
          return;
        }
        this.opcionestado = data;
        const actualStatus = this.getActualStatus();
        this.isStatusActive = this.activeStatus(actualStatus.idStatus);
        this.optionStatusActive = data.filter(
          status => status.active || status.idStatus == actualStatus.idStatus
        );
        console.log(this.optionStatusActive);
      },
      error => {
        this.routeAccordingError(error);
      }
    );
  }

  // este es el metodo que se encarga de administrar los estados, el cual debo clonar, para abrir el panel-row hermano
  changesStatesButton() {
    if (this.registrobool) this.refresh();
    this.registrobool = !this.registrobool;
  }

  toggleHistorySinester() {
    this.mostrarHistorialSiniestros = !this.mostrarHistorialSiniestros;
  }

  selectSufix(country: string) {
    let sufix;
    if (country) {
      sufix = country.slice(0, 2);
      if (['CL', 'PE', 'MX', 'BR'].includes(sufix)) {
        this.countryCodeSel = sufix;
      }
      return this.countryIso(this.countryCodeSel);
    }
  }

  countryIso(key) {
    const codeCountry = [...this.countryDni].find(n => n.isoCode === key);
    return codeCountry.name ? codeCountry.name : '';
  }

  activeStatus(idStatus): boolean {
    if (this.opcionestado) {
      const status = this.opcionestado.find(
        status => status.idStatus == idStatus
      );
      return status ? status.active : false;
    }

    return false;
  }

  getActualStatus() {
    if (this.opcionestado && this.registerPerson) {
      return this.opcionestado.find(
        estado => estado.idStatus == this.registerPerson.idStatus
      );
    }
  }

  onStatusChange(idStatus) {
    this.isStatusActive = this.activeStatus(idStatus);
  }

  ngOnDestroy(): void {
    this.infoClient.unsubscribe();
  }

  statusDisabled(nameStatus) {
    const disableIf = {
      BLOQUEADO: false,
      DESBLOQUEADO: true,
    };
    // console.log({name :nameStatus, deshabiitado: disableIf[nameStatus]});
    console.log(nameStatus);

    return true;
  }

  public loadCountries(): void {
    this.findCountriesSubs = this.countriesService.findCountries().subscribe(
      data => {
        if (this.errorInResponse(data)) {
          return;
        }

        // let a:CountryDTO= new CountryDTO();
        // a.name="Ninguno";
        this.countries = data;
        // this.countries.unshift(a);
        this.getCountries(data);
      },
      error => {
        this.routeAccordingError(error);
      }
    );
  }

  public getCountries(countries: CountryDto[]): void {
    this.countriesDto = countries.map(x => {
      return { value: x.isoCode, label: x.name };
    });

    this.countriesDto.unshift({
      value: '',
      label: this.i18n.getTranslation(
        'RSCFC_DEBTORS_REPORTS_COMPONENT_COLUMN_DEBTORS_TABLE_SELECT'
      ),
    });
  }

  shouldShowUnlockButton(): boolean {
    return this.authService.isAllowedHtmlElement(19505, 'ML_BTN_UNLOCK_TEMP');
  }
}
